import {plural, t} from "@lingui/core/macro";

const pointsRequirement = (numPoints: number) =>
    plural(numPoints, {
        one: "Earn # energy point",
        other: "Earn # energy points",
    });

export const getRequirementsForModel = (model: string): Array<string> => {
    switch (model) {
        case "spunky_sam":
        case "marcimus":
        case "mr_pink":
        case "mr_pants":
        case "old_spice_man":
            return [pointsRequirement(10000)];
        case "female_robot":
        case "male_robot":
        case "orange_juice_squid":
        case "purple_pi":
            return [pointsRequirement(50000)];
        case "winston":
            return [t`Make a spin-off of any scratchpad`];
        case "ohnoes":
            return [t`Finish watching a computer programming talk-through`];
        case "hopper":
            return [t`Create a program from scratch`];
        default:
            return [];
    }
};

export const getRequirementsForPart = (part: string): Array<string> => {
    switch (part) {
        case "leafers_seedling_style":
        case "piceratops_seedling_style":
        case "duskpin_seedling_style":
        case "primosaur_seedling_style":
        case "starky_seedling_style":
            return [pointsRequirement(10000)];
        case "leafers_sapling_style":
        case "piceratops_sapling_style":
        case "duskpin_sapling_style":
        case "primosaur_sapling_style":
        case "starky_sapling_style":
        case "female_robot_amelia_style":
        case "male_robot_johnny_style":
            return [pointsRequirement(50000)];
        case "leafers_tree_style":
        case "piceratops_tree_style":
        case "duskpin_tree_style":
        case "primosaur_tree_style":
        case "starky_tree_style":
        case "female_robot_ada_style":
        case "male_robot_donald_style":
            return [pointsRequirement(100000)];
        case "leafers_ultimate_style":
        case "piceratops_ultimate_style":
        case "duskpin_ultimate_style":
        case "primosaur_ultimate_style":
        case "starky_ultimate_style":
        case "female_robot_grace_style":
        case "male_robot_hal_style":
            return [pointsRequirement(250000)];
        case "winston_default_style":
            return [t`Make changes to an official program`];
        case "winston_baby_style":
            return [t`Make changes to another user's program`];
        case "ohnoes_default_style":
            return [t`Finish watching a computer programming talk-through`];
        case "hopper_happy_style":
            return [t`Create a program from scratch`];
        case "hopper_jumping_style":
            return [t`Complete a coding challenge`];
        case "hopper_cool_style":
            return [t`Complete a coding challenge`];
        default:
            return [];
    }
};
